export enum LibraryItemType {
  THIRD_PARTY_COST = 'LibraryThirdPartyCost',
  DELIVERABLE = 'LibraryDeliverableTemplate',
  COMPONENT = 'LibraryComponentTemplate',
  FOLDER = 'LibraryFolder',
}
